import * as Logger from "js-logger";

export class ResourceLoader {
    private static _loadInProgress = 0;

    static async load<T>(resourcePath: string, converter: (response: Response) => Promise<T>): Promise<T> {
        try {
            Logger.debug(`Loading resource ${resourcePath}...`);
            ResourceLoader._loadInProgress++;
            let response = await fetch(resourcePath, { credentials: "same-origin" });
            if (!response.ok) {
                throw new Error(`HTTP error status: ${response.status}`);
            }
            let result = await converter(response);
            Logger.debug(`Resource ${resourcePath} loaded successfully`);
            ResourceLoader._loadInProgress--;
            return result;
        } catch (e) {
            Logger.error(`Loading resource failed ${resourcePath}`, e);
            ResourceLoader._loadInProgress--;
            throw e;
        }
    }

    static get loadInProgress() {
        return ResourceLoader._loadInProgress;
    }

    static registerLoad() {
        ResourceLoader._loadInProgress++;
    }
    static unregisterLoad() {
        ResourceLoader._loadInProgress--;
    }

    static loadAsArrayBuffer(resourcePath: string): Promise<ArrayBuffer> {
        return ResourceLoader.load(resourcePath, it => it.arrayBuffer());
    }

    static loadAsBlob(resourcePath: string): Promise<Blob> {
        return ResourceLoader.load(resourcePath, it => it.blob());
    }

    static loadAsText(resourcePath: string): Promise<string> {
        return ResourceLoader.load(resourcePath, it => it.text());
    }

    static loadAsJson(resourcePath: string): Promise<any> {
        return ResourceLoader.load(resourcePath, it => it.json());
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/earth/core/resourceLoader.ts